import React from 'react'
import FadeInOut from "../../../component/Global/FadeInOut";
import farnelllogo from "src/assets/images/farnell.png";
import element14logo from "src/assets/images/element14-logo.png";
import newarkiconone from "src/assets/images/newark-store-icon1.png";
import newarkicontwo from "src/assets/images/newark-store-icon2.png";
import newarkiconthree from "src/assets/images/newark-store-icon3.png";
import System from 'src/helper/system';
import Constants from 'src/helper/Constants';

export const ProductDetailEsop = () => {
  const { speedBoats: { japanAbbr }} = Constants
  const isEligibleForElement = System.getCurrentRegionWithType(japanAbbr) ? false : Constants.countryCodesForFarnalElement.includes(System.getCountryCode());
  const { translation: t } = System;
  return (
    <>
      <FadeInOut show={true} duration={500} className={'visit-newark-box'}>
        <div className='d-flex justify-content-between'>
          <span className='new-tag'>
            <p>New</p>
          </span>
          <span className='pdp-newark-logo'>
            <img src={isEligibleForElement ? element14logo : farnelllogo} />
          </span>

        </div>
        <div className='pdp-newark-content text-center'>
          <h1 className='font-oswald font-28 text-darkgreen text-center'>{isEligibleForElement ? t('visitElement14Store') : t('visitFarnellStore')}</h1>
          <p className='font-arial font-13 mt-2 mb-3 text-center'>{isEligibleForElement ? `${t('element14Desc')}:` : `${t('farnellDesc')}:`}</p>
          <div className='d-flex pdp-newark-content-list '>
            <span>
              <img src={newarkiconone} />
            </span>
            <div>
              <h5 className='font-arial font-13 mb-0 text-left mt-0'><b>{t('prototypeQuantities')}</b></h5>
              <p className='font-arial font-13 text-left mb-0'>{t('productsInStock')}</p>
            </div>
          </div>

          <div className='d-flex pdp-newark-content-list '>
            <span>
              <img src={newarkicontwo} />
            </span>
            <div>
              <h5 className='font-arial font-13 mb-0 text-left mt-0'><b>{t('wideRangeProducts')}</b></h5>
              <p className='font-arial font-13 text-left mb-0'>{t('landingSuppliers')}</p>
            </div>
          </div>

          <div className='d-flex pdp-newark-content-list '>
            <span>
              <img src={newarkiconthree} />
            </span>
            <div>
              <h5 className='font-arial font-13 mb-0 text-left mt-0'><b>{t('fastAndReliable')}</b></h5>
              <p className='font-arial font-13 text-left mb-0'>{t('sameDayDispatch')},<br /> {t('delivery24And28')}</p>
            </div>
          </div>
          <a target={"_blank"} href={isEligibleForElement ? "https://www.element14.com/" : 'http://jp.farnell.com/'} className='bs5 btn btn-secondary m-auto'>{isEligibleForElement ? t('visitElement14') : t('visitFarnell')}</a>
        </div>
      </FadeInOut>
    </>
  )
}
